import styled from 'styled-components'
import ListItemStyle from '@material-ui/core/ListItem'

export const ListItem = styled(ListItemStyle).attrs((props) => ({
	...props,
	component: 'li',
	button: true
}))`
  && {
    width: 100%;
	min-height: unset;
	height: fit-content;
    padding: 0;
    background: ${({ active, theme }) => active ? theme.navbar.active.background : 'transparent'};
    color: ${({ active, theme }) => active ? theme.navbar.active.text : theme.navbar.text};
    font-weight: ${({ active, theme }) => active ? theme.navbar.active.fontWeight : theme.navbar.fontWeight};
	&:hover:not(.dashboard) {
      background: ${({ theme }) => theme.navbar.active.background};
	}
    > svg {
      width: auto;
      height: 16px;
    }
  }
`